module.exports = "<header id=\"hdr\">\n  <div class=\"container\">\n    <h1>Header Nav Goes Here</h1>\n  </div>\n</header>"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/components/site-header/site-header.component.html
// module id = ../../../../../src/app/components/site-header/site-header.component.html
// module chunks = main